<template lang="html">
  <div>
    <b-row>
      <b-col sm="12">
        <b-card style="height:770px;">
          <b-row>
            <b-col sm="3" style="height:700px;">
              <b-row class="pl-3">
                <b-col sm="12" class="pb-4">
                  <span class="card-title wise-card-title">대분류(1Depth)</span>
                </b-col>
                <b-col sm="12" style="overflow-y:scroll;height:650px;">
                  <b-table
                    outlined
                    selectable
                    :select-mode="'single'"
                    selectedVariant="secondary"
                    :fields="depth1Fields"
                    :items="depth1Items"
                    @row-selected="rowSelected"
                  >

                    <template slot="item_name" slot-scope="row">
                      <div>{{row.item.item_code}}</div>
                      <b-form-input v-on:keyup.enter="updateGroupName(row.item)" v-model="row.item.item_name" placeholder="Enter code name"></b-form-input>
                    </template>
                    <template slot="관리" slot-scope="row">
                    <span v-if="row.item.saved" >
                      <b-button variant="outline-primary" v-on:click="updateCodeName(row.item.item_code,row.item.item_name)">코드명 수정</b-button>
                    </span>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="3">
              <b-row class="pl-3">
                <b-col sm="12" class="pb-4">
                  <span class="card-title wise-card-title">상세분류(2Depth)</span>
                </b-col>
                <b-col sm="12" style="overflow-y:scroll;height:650px;">
                  <b-table
                    outlined
                    selectable
                    :select-mode="'single'"
                    selectedVariant="secondary"
                    :fields="depth2Fields"
                    :items="depth2Items"
                    @row-selected="depth2_selected"
                  >
                  <template slot="item_name" slot-scope="row">
                    <div>{{row.item.item_code}}</div>
                    <b-form-input v-on:keyup.enter="updateGroupName(row.item)" v-model="row.item.item_name" placeholder="Enter code name"></b-form-input>
                  </template>
                  <template slot="관리" slot-scope="row">
                    <span v-if="row.item.saved" >
                      <c-switch size="lg" type="text" variant="primary-outline-alt" v-model="row.item.item_active" v-on:change="updateCodeActive(row.item)" on="On" off="Off" :checked="true"/>
                      <b-button variant="outline-primary" v-on:click="updateCodeName(row.item.item_code,row.item.item_name)">코드명 수정</b-button>
                    </span>
                    <b-button variant="success" v-if="!row.item.saved" v-on:click="insertCode(row.item)">저장</b-button>
                  </template>
                  </b-table>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="3">
              <b-row class="pl-3">
                <b-col sm="12" class="pb-4">
                  <span class="card-title wise-card-title">상세분류(3Depth)</span>
                </b-col>
                <b-col sm="12" style="overflow-y:scroll;height:650px;">
                  <b-table
                    outlined
                    selectable
                    :select-mode="'single'"
                    selectedVariant="secondary"
                    :fields="depth3Fields"
                    :items="depth3Items"
                    @row-selected="depth3_selected"
                  >
                  <template slot="item_name" slot-scope="row">
                    <div>{{row.item.item_code}}</div>
                    <b-form-input v-on:keyup.enter="updateGroupName(row.item)" v-model="row.item.item_name" placeholder="Enter code name"></b-form-input>
                  </template>
                  <template slot="관리" slot-scope="row">
                    <span v-if="row.item.saved" >
                      <c-switch size="lg" type="text" variant="primary-outline-alt" v-model="row.item.item_active" v-on:change="updateCodeActive(row.item)" on="On" off="Off" :checked="true"/>
                      <b-button variant="outline-primary" v-on:click="updateCodeName(row.item.item_code,row.item.item_name)">코드명 수정</b-button>
                    </span>
                    <b-button variant="success" v-if="!row.item.saved" v-on:click="insertCode(row.item)">저장</b-button>
                  </template>
                  </b-table>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="3">
              <b-row class="pl-3">
                <b-col sm="12" class="pb-4">
                  <span class="card-title wise-card-title">상세분류(4Depth)</span>
                </b-col>
                <b-col sm="12" style="overflow-y:scroll;height:650px;">
                  <b-table
                    outlined
                    selectable
                    :select-mode="'single'"
                    selectedVariant="secondary"
                    :fields="depth4Fields"
                    :items="depth4Items"
                  >
                  <template slot="item_name" slot-scope="row">
                    <div>{{row.item.item_code}}</div>
                    <b-form-input v-on:keyup.enter="updateGroupName(row.item)" v-model="row.item.item_name" placeholder="Enter code name"></b-form-input>
                  </template>
                  <template slot="관리" slot-scope="row">
                    <span v-if="row.item.saved" >
                      <c-switch size="lg" type="text" variant="primary-outline-alt" v-model="row.item.item_active" v-on:change="updateCodeActive(row.item)" on="On" off="Off" :checked="true"/>
                      <b-button variant="outline-primary" v-on:click="updateCodeName(row.item.item_code)">코드명 수정</b-button>
                    </span>
                    <b-button variant="success" v-if="!row.item.saved" v-on:click="insertCode(row.item)">저장</b-button>
                  </template>
                  </b-table>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import swal from 'sweetalert2'
const moment = require("moment");
import cSwitch from '../../components/Switch';

export default {
  components: {
    cSwitch,
  },
  data() {
    return {
      depth1Fields: [{'item_name': {'label': '코드명',}}, '관리'], // 코드 뎁스1 테이블 필드
      depth1Items: [], // 코드 뎁스1 테이블 데이터
      depth2Fields: [{'item_name': {'label': '코드명',}}, '관리'], // 코드 뎁스2 테이블 필드
      depth2Items: [], // 코드 뎁스2 테이블 데이터
      depth3Fields: [{'item_name': {'label': '코드명',}}, '관리'], // 코드 뎁스3 테이블 필드
      depth3Items: [], // 코드 뎁스3 테이블 데이터
      depth4Fields: [{'item_name': {'label': '코드명',}}, '관리'], // 코드 뎁스4 테이블 필드
      depth4Items: [], // 코드 뎁스4 테이블 데이터

      select_depth1_item_code: '',
      select_depth2_item_code: '',
      select_depth3_item_code: '',
      select_depth4_item_code: '',
      now_depth : '',

    }
  },
  watch: {
  },
  mounted: function() {
    var token = sessionStorage.getItem("myToken");
    // 1Depth (ROOT)코드 리스트 조회
    this.$http.get('/api/select/itemCodeList?access_token='+token + '&parentCode=ROOT')
    .then((result) => {
      this.depth1Items = result.data;
    })
  },
  methods: {
    // 메소드명 : selectItemUnitList(parentCode, depth)
    // ### 코드리스트 조회 ###
    // parentCode를 기준으로 코드리스트를 조회
    //
    // 최초작성 : 2019.05.23
    // 파라미터 :
    //  - parentCode(부모 아이템 코드)
    //  - depth(조회되는 코드리스트가 몇번째 뎁스의 코드리스트인지에 대한 정보)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.05.23  이승훈   최초작성
    // *************************
    selectItemUnitList(parentCode, depth){
      var depthXItems = [];
      var token = sessionStorage.getItem("myToken");
      this.$http.get('/api/select/itemCodeList?access_token='+token + '&parentCode=' + parentCode)
      .then((result) => {
        depthXItems = result.data;
        var unit = {};
        unit = this.$_.clone(depthXItems[depthXItems.length-1]);
        if (unit && unit.item_parent_code){
          unit.item_code = unit.item_parent_code + '_' + (unit.item_seq + 1);
          unit.item_name = '';
          unit.item_seq = (unit.item_seq + 1);
          unit.saved = false;
          depthXItems.push(unit);
          switch (depth) { // 몇번째 뎁스에 해당하는 코드리스트인지 파악
            case 2:
              this.depth2Items = this.$_.clone(depthXItems);
              break;
            case 3:
              this.depth3Items = this.$_.clone(depthXItems);
              break;
            case 4:
              this.depth4Items = this.$_.clone(depthXItems);
              break;
            default:
          }
        }
      })
    },
    // 1뎁스에서 특정 코드가 선택 됬을때 2뎁스의 하위 코드리스트 조회
    rowSelected(items) {
      this.depth2Items = []; // 초기화
      this.depth3Items = []; // 초기화
      this.depth4Items = []; // 초기화
      if (items && items.length > 0) {
        this.select_depth1_item_code = items[0].item_code;
        this.now_depth = 2;
        this.selectItemUnitList(items[0].item_code, 2);
      }
    },
    // 2뎁스에서 특정 코드가 선택 됬을때 3뎁스의 하위 코드리스트 조회
    depth2_selected(items){
      this.depth3Items = []; // 초기화
      this.depth4Items = []; // 초기화
      if (items && items.length > 0) {
        this.select_depth2_item_code = items[0].item_code;
        this.now_depth = 3;
        this.selectItemUnitList(items[0].item_code, 3);
      }
    },
    // 3뎁스에서 특정 코드가 선택 됬을때 4뎁스의 하위 코드리스트 조회
    depth3_selected(items){
      this.depth4Items = []; // 초기화
      if (items && items.length > 0) {
        this.select_depth3_item_code = items[0].item_code;
        this.now_depth = 4;
        this.selectItemUnitList(items[0].item_code, 4);
      }
    },
    // 메소드명 : deleteCode(unit)
    // ### 코드 삭제 ###
    // 해당 코드를 삭제
    //
    // 최초작성 : 2019.05.23
    // 파라미터 :
    //  - unit(JSON 형태의 코드 아이템 데이터)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.05.23  이승훈   최초작성
    // *************************
    deleteCode(unit){
      swal.fire({
        title: '코드 삭제!',
        text: "선택하신 코드를 삭제하시겠습니까?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK'
      }).then((swalResult) => {
        if (swalResult.value) {
          var token = sessionStorage.getItem("myToken");
          var unitCode = unit.item_code;
          // var id = histroyData.id;
          this.$http.get('/api/delete/itemCode?access_token='+token + '&unitCode=' + unitCode)
            .then((result) => {
              this.selectItemUnitList(unit.item_parent_code);
              swal.fire({
                // position: 'top-end',
                type: 'success',
                title: '코드를 삭제하였습니다.',
                showConfirmButton: false,
                timer: 1500
              })
          })
        }
      })
    },
    // 메소드명 : updateGroupName(unit)
    // ### 코드명 업데이트 ###
    // 해당 코드의 이름을 변경
    //
    // 최초작성 : 2019.05.23
    // 파라미터 :
    //  - unit(JSON 형태의 코드 아이템 데이터)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.05.23  이승훈   최초작성
    // *************************
    updateGroupName(unit){
      if(unit.saved != false){
        swal.fire({
          title: '코드 변경!',
          text: "선택하신 코드를 변경하시겠습니까?",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'OK'
        }).then((swalResult) => {
          if (swalResult.value) {
            var token = sessionStorage.getItem("myToken");
            unit.edit_id = this.$session.get('userId');
            unit.edit_date = moment().format('YYYY-MM-DD HH:mm:ss');

            var param = encodeURI(JSON.stringify(unit));
            var data = new FormData();
            data.append('unitObj', param);

            this.$http.post('/api/update/itemCode?access_token='+token, data, null)
              .then((result) => {
                swal.fire({
                  type: 'success',
                  title: '코드를 변경하였습니다.',
                  showConfirmButton: false,
                  timer: 1500
                })
            })
          }
        })
      }
    },
    // 메소드명 : updateCodeActive(unit)
    // ### 코드 사용여부 업데이트 ###
    // 해당 코드의 사용여부를 변경
    //
    // 최초작성 : 2019.05.23
    // 파라미터 :
    //  - unit(JSON 형태의 코드 아이템 데이터)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.05.23  이승훈   최초작성
    // *************************
    updateCodeActive(unit){
      swal.fire({
        title: '코드 변경!',
        text: "선택하신 코드를 변경하시겠습니까?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK'
      }).then((swalResult) => {
        if (swalResult.value) {
          var token = sessionStorage.getItem("myToken");
          unit.edit_id = this.$session.get('userId');
          unit.edit_date = moment().format('YYYY-MM-DD HH:mm:ss');

          var param = encodeURI(JSON.stringify(unit));
          var data = new FormData();
          data.append('unitObj', param);

          this.$http.post('/api/update/itemCodeActive?access_token='+token, data, null)
            .then((result) => {
              swal.fire({
                type: 'success',
                title: '코드를 변경하였습니다.',
                showConfirmButton: false,
                timer: 1500
              })
          })
        }else{
          if(unit.item_active == 'Y'){
            unit.item_active = 'N'
          }else{
            unit.item_active = 'Y'
          }
        }
      })
    },
    // 메소드명 : insertCode(unit)
    // ### 신규코드 저장 ###
    // 신규코드를 DB테이블에 저장
    //
    // 최초작성 : 2019.05.23
    // 파라미터 :
    //  - unit(JSON 형태의 코드 아이템 데이터)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.05.23  이승훈   최초작성
    // *************************
    insertCode(unit){
      swal.fire({
        title: '코드 저장!',
        text: "선택하신 코드를 저장하시겠습니까?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK'
      }).then((swalResult) => {
        if
         (swalResult.value) {
          var token = sessionStorage.getItem("myToken");

          unit.reg_id = this.$session.get('userId');
          unit.reg_date = moment().format('YYYY-MM-DD HH:mm:ss');
          var param = encodeURI(JSON.stringify(unit));
          var data = new FormData();
          data.append('unitObj', param);

          this.$http.post('/api/insert/itemCode?access_token='+token, data, null)
            .then((result) => {

              if (this.now_depth == 2){
                this.selectItemUnitList(this.select_depth1_item_code, 2);
              } else if(this.now_depth == 3) {
                this.selectItemUnitList(this.select_depth2_item_code, 3);
              } else if(this.now_depth == 4) {
                this.selectItemUnitList(this.select_depth3_item_code, 4);
              }

              swal.fire({
                type: 'success',
                title: '코드를 저장하였습니다.',
                showConfirmButton: false,
                timer: 1500
              })

          })
        }
      })
    },
    updateCodeName(item_code,item_name){
      swal.fire({
        title: '코드명 변경!',
        text: "선택하신 코드 명을 변경하시겠습니까?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK'
      }).then((swalResult) => {
        if (swalResult.value) {
          var token = sessionStorage.getItem("myToken");
          var queryParams = {};
          queryParams.item_code = item_code;
          queryParams.item_name = item_name;
          queryParams.edit_id = this.$session.get('userId');
          queryParams.edit_date = moment().format('YYYY-MM-DD HH:mm:ss');

          var param = encodeURI(JSON.stringify(queryParams));
          var data = new FormData();
          data.append('unitObj', param);

          this.$http.post('/api/update/itemCodeName?access_token='+token, data, null)
            .then((result) => {
              swal.fire({
                type: 'success',
                title: '코드명을 변경하였습니다.',
                showConfirmButton: false,
                timer: 1500
              })
            })
        }else{
          if(unit.item_active == 'Y'){
            unit.item_active = 'N'
          }else{
            unit.item_active = 'Y'
          }
        }
      })
    }
  }
}
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/views/common/CodeManagement.vue